import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const email = ['contact', 'granstark.co.jp'].join('@');

export default function RecruitApplyCtaSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section className="bg-navy py-16 md:py-24" id="apply-cta">
      <div className="w-full px-4 md:px-8 max-w-4xl mx-auto" ref={ref}>
        <div
          className={`text-center transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-[21px] md:text-3xl font-bold text-white mb-8">
            一緒に、安全と未来を創りませんか
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10">
            <a
              href="tel:08045635272"
              className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl p-6 hover:bg-white/15 transition-all duration-300"
            >
              <span className="w-10 h-10 mx-auto flex items-center justify-center text-gold mb-3">
                <i className="ri-phone-line text-2xl"></i>
              </span>
              <p className="text-gray-300 text-xs mb-1">電話応募（タップで発信）</p>
              <p className="text-white font-bold text-lg">TEL: 080-4563-5272</p>
            </a>

            <div className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl p-6">
              <span className="w-10 h-10 mx-auto flex items-center justify-center text-gold mb-3">
                <i className="ri-mail-line text-2xl"></i>
              </span>
              <p className="text-gray-300 text-xs mb-1">メール</p>
              <p className="text-white font-bold text-sm break-all">{email}</p>
            </div>

            <Link
              to="/contact"
              className="bg-[#E47911] rounded-xl p-6 flex flex-col items-center justify-center hover:bg-[#E47911]/90 transition-all duration-300 hover:-translate-y-0.5"
            >
              <span className="w-10 h-10 flex items-center justify-center text-white mb-3">
                <i className="ri-send-plane-line text-2xl"></i>
              </span>
              <p className="text-white font-bold text-lg flex items-center gap-2">
                応募フォームへ
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}